/* CK Living — Customer Stories: category tabs + tap-to-play video.
   No frameworks, no autoplay-with-sound, video loads only on tap. */
(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.cksInit) return;
    root.dataset.cksInit = '1';

    /* Tabs: filter tiles/videos by data-cks-cat. Without JS everything shows. */
    var tabs = root.querySelectorAll('.cks-tab');
    var items = root.querySelectorAll('[data-cks-cat]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var cat = tab.dataset.cksTab;
        tabs.forEach(function (t) {
          t.setAttribute('aria-pressed', t === tab ? 'true' : 'false');
        });
        items.forEach(function (item) {
          var itemCat = item.dataset.cksCat || 'all';
          item.hidden = cat !== 'all' && itemCat !== cat;
        });
      });
    });

    /* Tap-to-play: replace poster with a <video> only on demand. */
    root.querySelectorAll('.cks-video[data-src]').forEach(function (card) {
      var play = card.querySelector('.cks-video__play');
      if (!play) return;
      play.addEventListener('click', function () {
        if (card.classList.contains('is-playing')) return;
        var video = document.createElement('video');
        video.src = card.dataset.src;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        if (card.dataset.poster) video.poster = card.dataset.poster;
        card.appendChild(video);
        card.classList.add('is-playing');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cks-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
